module.exports = __webpack_public_path__ + "static/sergio-souza-tncsQE63ENU-unsplash-40b9b47ed66d4ee232cb018a3ebd56ed.jpg";